
<template>
  <div class="popup">

    <!-- SCENE -->
      <div class="scene animated fadeIn" v-show="!feedback">
        <div class="top">
          <img :src="'media/page3/' + items.activity.scenes[id].image" />
          <div class="right">
            <h2>{{items.activity.scenes[id].title}}</h2>
            <p>{{items.activity.scenes[id].text}}</p>
            <p>{{items.activity.scenes[id].prompt}}</p>
          </div>
        </div>
        <div class="bottom">
          <button class="fas" v-for="(item, index) in items.activity.scenes[id].options" @click="select(index)">
            <!-- <button @click="select(index)">{{items.activity.scenes[0].buttons[0]}}</button> -->
            <!-- <p>{{item.text}}</p> -->
            {{item.text}}
          </button>
        </div>
      </div>

    <!-- FEEDBACK -->
      <div class="feedback animated fadeIn" v-show="feedback">
        <h2>{{items.activity.scenes[0].options[0].feedHead}}</h2>
        <p v-html="items.activity.scenes[id].options[feedId].feedback"></p>
        <div class="buttons">
          <button class="button back" @click="tryAgain">{{items.activity.scenes[0].buttons[1]}}</button>
          <button class="button forward" @click="next">{{items.activity.scenes[0].buttons[2]}}</button>
        </div>
      </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      feedback: false,
      feedId: 0
    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {
    select(num) {
      this.feedId = num;
      this.feedback = true
      this.$emit("choose", num);
    },
    tryAgain() {
      this.feedback = false
      this.$emit("tryAgain");
    },
    next() {
      this.feedback = false
      this.$emit("next");
    }
  },
  mounted() {

  },
  beforeDestroy() {

  },
  components: {},
  props: ["id"]
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Popup.vue?3a58c9bd